import { Injectable } from '@angular/core';
import { Link } from '../models/link';
import { PageService } from './page.service';
import { CrudService } from './crud.service';
import { ApplicationStateService } from './application-state.service';
import { LinkFactory } from '../models/factories/link-factory';
import { UrlWhitelist } from '../../environments/configs/url-whitelist';

@Injectable({
    providedIn: 'root'
})
export class LinkService {

    private links: Array<Link>;
    private indexToLinksMap: Map<number, Array<Link>> = new Map();

    constructor(private applicationStateService: ApplicationStateService,
                private crudService: CrudService,
                private pageService: PageService,
                private linkFactory: LinkFactory) {

    }

    setLinks(links: Array<Link>): void {
        this.links = [];
        this.indexToLinksMap = new Map();
        links.forEach(entity => this.includeToIndexMap(entity));
    }

    /**
     * Similar to setLinks(links) but in addition the passed values are transformed in forehand.
     * This method purpose is to do the transformation and the storing in just one for-Loop.
     * @param objects
     */
    setObjectsToLinks(objects: Array<any>): void {
        this.links = [];
        this.indexToLinksMap = new Map();
        objects.forEach(entity => {
            this.includeToIndexMap(this.linkFactory.buildFromObject(entity));
        });
    }

    getLinks(): Promise<Array<Link>> {

        return new Promise<Array<Link>>(resolve => {

            const thiz = this;

            if (thiz.links) {
                resolve(thiz.links);

                return;
            }

            return thiz.crudService.getAllEntitiesOfBook(Link, this.linkFactory)
                .then(links => {
                    this.setLinks(links as Array<Link>);
                    resolve(links as Array<Link>);
                });
        });
    }

    getLinksOfPage(index: number): Promise<Array<Link>> {

        return new Promise(resolve => {
            this.getLinks()
                .then(() => {
                    if (this.indexToLinksMap.get(index)) {
                        resolve(this.indexToLinksMap.get(index));
                    } else {
                        resolve([]);
                    }
                });
        });
    }

    getLinkOfPages(pageIndex: number): Promise<Array<Link>> {

        return new Promise<Array<Link>>(resolve => {
            let links = [];
            const promises = [];
            // Add the the promises of all search pages to the array
            for (let runningPageIndex = 0;
                 runningPageIndex < this.applicationStateService.currentViewMode.pagesToShow;
                 runningPageIndex++) {
                promises.push(this.getLinksOfPage(pageIndex + runningPageIndex));
            }

            Promise.all(promises)
                .then(values => {

                    values.forEach(value => links = links.concat(value));
                    resolve(links);
                });
        });
    }

    createPageFavorite(link: Link): Promise<Link> {
        return this.crudService.create(link) as Promise<Link>;
    }

    updatePageFavorite(link: Link): Promise<Link> {
        return this.crudService.update(link) as Promise<Link>;
    }

    deletePageFavorite(link: Link): Promise<boolean> {
        return this.crudService.remove(link) as Promise<boolean>;
    }

    logUsage(link: Link): Promise<boolean> {
        return this.crudService.log(link) as Promise<boolean>;
    }

    checkDigi4SchoolRedirect(link: string): void {
        if (!link.startsWith('http://') && !link.startsWith('https://')) {
            link = `https://${link}`;
        }

        if (UrlWhitelist.isOnWhiteList(link)) {
            window.open(link, '_blank');

            return;
        }

        const redirectUrl = `https://fwd.digi4school.at/?l=${encodeURIComponent(link)}`;
        window.open(redirectUrl, '_blank');
    }

    private includeToIndexMap(link: Link): void {
        const indexOfLink = this.pageService.getIndexByPageId(link.pageId);
        link.index = indexOfLink;
        this.links.push(link);

        if (!this.indexToLinksMap.get(indexOfLink)) {
            this.indexToLinksMap.set(indexOfLink, [link]);
        } else {
            this.indexToLinksMap.get(indexOfLink)
                .push(link);
        }
    }
}
